import React from "react";
import PropTypes from "prop-types";
import PreviewCompatibleImage from "./PreviewCompatibleImage";

const FeatureGrid = ({ gridItems, singleColumn = false, className = "" }) => (
  <div
    className={`columns is-multiline ${
      singleColumn ? "index-blurbs-grid" : ""
    } ${className}`.trim()}
  >
    {gridItems.map((item) => (
      <div
        key={item.text}
        className={singleColumn ? "column is-12" : "column is-6"}
      >
        <section
          className={singleColumn ? "section index-blurb-item" : "section"}
        >
          <div className="has-text-centered">
            <div
              className={singleColumn ? "index-blurb-image-wrap" : ""}
              style={{
                width: singleColumn ? "100%" : "240px",
                display: singleColumn ? "block" : "inline-block",
              }}
            >
              <PreviewCompatibleImage imageInfo={item} />
            </div>
          </div>
          <p className={singleColumn ? "index-blurb-text" : ""}>{item.text}</p>
        </section>
      </div>
    ))}
  </div>
);

FeatureGrid.propTypes = {
  gridItems: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      text: PropTypes.string,
    }),
  ),
  singleColumn: PropTypes.bool,
  className: PropTypes.string,
};

export default FeatureGrid;
